<template>
  <div class="dialog-warp">
    <el-form class="dialog-form" ref="info" :model="info" :rules="rules" size="small"
             label-width="200px">
      <el-row>
        <el-col :span="22">
          <el-form-item label="提醒人员名称：" prop="bwcName">
            <el-input v-model.trim="info.bwcName" placeholder="请输入提醒人员名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="常用联系方式：" prop="bwcContact">
            <el-input v-model.trim="info.bwcContact" placeholder="请填写常用联系方式"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="提醒内容" prop="remindContent">
            <el-checkbox-group v-model="info.remindContent">
              <el-checkbox label="1">企业电费</el-checkbox>
              <el-checkbox label="2">企业水费</el-checkbox>
              <el-checkbox label="3">公寓电费</el-checkbox>
              <el-checkbox label="4">公寓水费</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="text-right" style="margin-top: 20px;">
      <el-button size="mini" @click="close">返回</el-button>
      <el-button size="mini" type="success" :loading="submitLoading" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";

  export default {
    data() {
      return {
        submitLoading:false,
        info: {
          bwcName: '',
          bwcContact: '',
          bwcFace:'',
          remindContent: [],
        },
        rules: {
          bwcName: [
            {required: true, message: '请输入提醒人员名称', trigger: ['blur', 'change']},
          ],
          bwcContact: [
            {required: true, message: '请填写常用联系方式', trigger: ['blur', 'change']},
            { pattern: global.phoneRule, message: "手机号码格式错误" }
          ],
          remindContent: [
            {required: true, message: '请选择提醒内容', trigger: ['blur', 'change']},
          ]
        }
      }
    },
    created() {
    },
    mounted() {
      if(this.bwcId){
        this.init()
      }
    },
    props:['bwcId'],
    computed: {},
    methods: {
      init() {
        this.openSecrecyDialog = false;
        getData.getWalletContact({bwcId:this.bwcId}).then(res => {
          if (res.data.code == 1) {
            if (res.data.data) {
              this.info.bwcContact = res.data.data.bwcContact;
              this.info.bwcName = res.data.data.bwcName;
              this.info.bwcId = res.data.data.bwcId;
              this.info.bwcFace = res.data.data.bwcFace;
              this.info.remindContent = res.data.data.bwcFace ? res.data.data.bwcFace.split(',') : [];
            }
          }
        }).catch(_ => {
          console.log(`getContractDefaultSetting:::${_}`)
        })
      },
      close() {
        this.$emit('init')
      },
      submit() {
        this.submitLoading = true;
        this.$refs["info"].validate((valid) => {
          if (valid) {
            this.info.bwcFace = this.info.remindContent.join(',')
            getData.addWalletContact(this.info).then(res => {
              this.submitLoading = false;
              if (res.data.code == 1) {
                if(this.bwcId){
                  this.$message({ message: "编辑成功", type: "success"});
                }else{
                  this.$message({ message: "新增成功", type: "success"});
                }

                this.close();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch(err => {
              this.submitLoading = false;
              this.$message.error("服务器开小差了...");
            });

          } else {
            this.submitLoading = false;
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .input-title {
    font-size: 10px;
    line-height: 32px;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/add-remind-staff.vue